import React from "react";
import { Button, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BoutonAllerAuSondage = ({ label }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Button 
    variant="outlined" 
    onClick={() => navigate("/survey")}
    sx={{
      color: "#fff",    
      backgroundColor: "#3399FF !important",          // texte
      borderColor: "#3399FF",        // bordure
      marginLeft: 1,
      marginTop: 1,
      fontWeight: "bold",
      fontSize: isMobile ? "0.5rem" : "0.7rem",
      transition: "all 0.3s ease",
      minHeight: "48px",
      paddingX: 3,
      paddingY: 2,
      borderRadius: 1,
      '&:hover': {
        backgroundColor: "#3399FF",  // fond au survol
        color: "#fff",               // texte au survol
      }, 
    }}
    >
      {label}
    </Button>
  );
};

export default BoutonAllerAuSondage;
